import * as Yup from 'yup';

export const addCohortFormSchema = () =>
  Yup.object().shape({
    name: Yup.string().required('Name is required').min(1, 'Name is required'),
    service_classes: Yup.array().min(1, 'At least one service class is required'),
  });
